/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { Button } from '@mui/material';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import AppCreation from './AppCreation';

const AppCreationBtn = () => {
    const [openAppCreationModal, setOpenAppCreationModal] = useState(false);
    const handleCloseDialog = () => {
        setOpenAppCreationModal(false)
    }
    return (
        <>
            <Button variant="contained" sx={{ background: (theme) => theme.palette.gradiant.main, float: 'right' }}
                onClick={() => setOpenAppCreationModal(true)}  >Register Application</Button>
            <DialogContainer
                open={openAppCreationModal}
                handleClose={handleCloseDialog}
            >
                <AppCreation handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default AppCreationBtn;
